var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "PriceMatch",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-price-match","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M113.9 38.2c-8.3 0-15.1 6.8-15.1 15.1s6.8 15.1 15.1 15.1S129 61.6 129 53.3c-.1-8.3-6.8-15.1-15.1-15.1zm0 21.1c-3.3 0-6.1-2.7-6.1-6.1s2.7-6.1 6.1-6.1 6.1 2.7 6.1 6.1-2.8 6.1-6.1 6.1z"/>
  <path d="M72.5 154l-.4.4c-2.2 2.9-4.4 4.2-6.7 4.2-3 0-5.9-2.2-6.7-3L9.8 105.2c-2.4-4.6 1.9-8.7 2.4-9.2l.1-.1 73.4-74 49.5 1.9c5.5.6 6.2 5 6.3 6.3l5.3 47.4-7.5 7.7c3.1 1 6 2.3 8.7 4l8.2-8.4-5.7-51.2c-.3-4.8-3.6-13.8-14.6-14.8l-53.8-2.1L6.2 89.4c-3.8 3.4-9.3 11.9-3.9 20.9l.3.4L52.3 162c.6.6 5.9 5.7 13.1 5.7 3.6 0 8.9-1.3 13.7-7.6l13.2-13.6c-1.7-2.7-3.1-5.5-4.2-8.6L72.5 154z"/>
  <path d="M206.8 138.5c8.3 0 15.1-6.8 15.1-15.1s-6.8-15.1-15.1-15.1-15.1 6.8-15.1 15.1c.1 8.4 6.8 15.1 15.1 15.1zm0-21.1c3.3 0 6.1 2.7 6.1 6.1s-2.7 6.1-6.1 6.1-6.1-2.7-6.1-6.1 2.8-6.1 6.1-6.1z"/>
  <path d="M243.4 99.8c-.3-4.8-3.6-13.8-14.6-14.8L175 83l-15.9 16.1c1.9 2.4 3.5 5.1 4.9 7.9l14.7-14.8 49.5 1.9c5.5.6 6.2 5 6.3 6.3l5.3 47.4-74.3 76.4-.4.4c-2.2 2.9-4.4 4.2-6.7 4.2-3 0-5.9-2.2-6.7-3l-48.9-50.5c-2.4-4.6 1.9-8.7 2.4-9.2l.1-.1 4.5-4.5c-2.8-1.3-5.5-2.9-7.9-4.8l-2.7 2.7c-3.8 3.4-9.4 11.9-3.9 20.9l.3.4 49.7 51.3c.6.6 5.9 5.7 13.1 5.7 3.6 0 8.9-1.3 13.7-7.6l77-79.3-5.7-51z"/>
  <path d="M139.9 120.2h-25.8c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h25.8c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5z"/>
  <path d="M139.9 138.8h-25.8c-2.5 0-4.5-2-4.5-4.5s2-4.5 4.5-4.5h25.8c2.5 0 4.5 2 4.5 4.5s-2 4.5-4.5 4.5z"/>
  <path d="M126.8 165.4c-22.6 0-41-18.4-41-41s18.4-41 41-41 41 18.4 41 41-18.4 41-41 41zm0-73.1c-17.7 0-32 14.4-32 32s14.4 32 32 32 32-14.4 32-32-14.3-32-32-32z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/price-match.svg